export const COOKIE_HEADER_KEY = 'cookie';
export const SESSION_COOKIE = 'sessionHash';
export const EXPIRY_THRESHOLD_DAYS: number = 120;
export const ONE_DAY_IN_MILLISECONDS: number = 24 * 60 * 60 * 1000;
export const ASSET_ID_QUERY_PARAM = 'assetId';
export const INCIDENT_ID = 'incidentTypeId';
export const ACCOUNT_ID_QUERY_PARAM = 'accountId';
export const AGREEMENT_ID_QUERY_PARAM = 'agreementId';
export const CLIENT_COOKOIE = 'client';
